import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type BatchNotificationsSmsSendCommand = {
    readonly _id: string;
    readonly _type: "BATCH_NOTIFICATIONS_SMS_SEND_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly recipients: string[];
    readonly message: string;
};

type FactoryParams = Except<
    BatchNotificationsSmsSendCommand,
    "_id" | "_type" | "_createdAt"
>;
const batchNotificationsSmsSendCommandFactory = (params: FactoryParams) => {
    const notificationsSmsSendCommand: BatchNotificationsSmsSendCommand = {
        ...params,
        _id: generateId({ prefix: "notification_sms_send_command__" }),
        _type: "BATCH_NOTIFICATIONS_SMS_SEND_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return notificationsSmsSendCommand;
};

const batchNotificationsSmsSendCommandZodSchema: z.ZodSchema<BatchNotificationsSmsSendCommand> =
    z.object({
        _id: z.string(),
        _type: z.literal("BATCH_NOTIFICATIONS_SMS_SEND_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        recipients: z.string().array(),
        message: z.string(),
    });
export {
    batchNotificationsSmsSendCommandFactory,
    batchNotificationsSmsSendCommandZodSchema,
};
export type {
    BatchNotificationsSmsSendCommand,
    FactoryParams as batchNotificationsSmsSendCommandFactoryParams,
};
